module.exports = __webpack_public_path__ + "public/images/Kakao_logo.2b1f4963c0a74cf8c92ce68ffd820802.svg";